import {useSyncExternalStore} from 'react';

const mobileViewport = window.matchMedia('(max-width: 767px)');
const subscribe = (onChange) => {
    if (mobileViewport.addEventListener) {
        mobileViewport.addEventListener('change', onChange);

        return () => mobileViewport.removeEventListener('change', onChange);
    }

    mobileViewport.addListener(onChange);

    return () => mobileViewport.removeListener(onChange);
};
const getSnapshot = () => mobileViewport.matches;

const useIsMobileViewport = () => useSyncExternalStore(subscribe, getSnapshot, () => false);

export default useIsMobileViewport;
